import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LEAVE_TYPES } from "./constants";

export const LeaveDialog = ({
  open,
  onOpenChange,
  activeEmployees,
  leaveData,
  setLeaveData,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New Leave Request</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div>
            <Label>Employee *</Label>
            <Select value={leaveData.employee_id} onValueChange={(v) => setLeaveData({...leaveData, employee_id: v})}>
              <SelectTrigger data-testid="leave-employee-select">
                <SelectValue placeholder="Select employee" />
              </SelectTrigger>
              <SelectContent>
                {[...activeEmployees].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(emp => (
                  <SelectItem key={emp.id} value={emp.id}>
                    {emp.first_name} {emp.last_name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <Label>Leave Type</Label>
            <Select value={leaveData.leave_type} onValueChange={(v) => setLeaveData({...leaveData, leave_type: v})}>
              <SelectTrigger data-testid="leave-type-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {[...LEAVE_TYPES].sort((a, b) => (a.label || '').localeCompare(b.label || '')).map(t => (
                  <SelectItem key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Start Date</Label>
              <Input 
                type="date"
                value={leaveData.start_date}
                onChange={(e) => setLeaveData({...leaveData, start_date: e.target.value})}
                data-testid="leave-start-date"
              />
            </div>
            <div>
              <Label>End Date</Label>
              <Input 
                type="date"
                value={leaveData.end_date}
                onChange={(e) => setLeaveData({...leaveData, end_date: e.target.value})}
                data-testid="leave-end-date"
              />
            </div>
          </div>

          <div>
            <Label>Number of Days</Label>
            <Input 
              type="number"
              value={leaveData.days}
              onChange={(e) => setLeaveData({...leaveData, days: parseFloat(e.target.value) || 0})}
              data-testid="leave-days"
            />
          </div>

          <div>
            <Label>Reason</Label>
            <Input 
              value={leaveData.reason}
              onChange={(e) => setLeaveData({...leaveData, reason: e.target.value})}
              placeholder="Optional"
              data-testid="leave-reason"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSubmit} className="bg-green-600 hover:bg-green-700" data-testid="submit-leave-btn">
            Submit Request
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
